import moment from 'moment';

export const getLastCompletedQuarterDates = () => {
    const currentYear = moment().year();
    const currentMonth = moment().month();

    let lastQuarterEndMonth = Math.floor(currentMonth / 3) * 3 - 1;
    let lastQuarterStartMonth = lastQuarterEndMonth - 2;
    let lastQuarterYear = currentYear;

    if (lastQuarterEndMonth < 0) {
        lastQuarterYear -= 1;
        lastQuarterEndMonth += 12;
        lastQuarterStartMonth += 12;
    }

    const startDate = moment({ year: lastQuarterYear, month: lastQuarterStartMonth, day: 1 }).format('YYYY-MM-DD');
    const endDate = moment({ year: lastQuarterYear, month: lastQuarterEndMonth }).endOf('month').format('YYYY-MM-DD');

    return [startDate, endDate];
};

export const getTrailing13MonthsDates = () => {
    const endDate = moment().format('YYYY-MM-DD');
    const startDate = moment([moment().year(), moment().month(), 1]).subtract(13, 'month').format('YYYY-MM-DD');
    return [startDate, endDate];
}
